import { useMemo } from "react";

import { DropdownSelectOption } from "@whoosh/design-system/src/components/controls/DropdownSelect";
import { formatHHMM } from "@whoosh/utilities/src/dates";

type TimeSlotNode = {
  readonly id: string;
  readonly time: string;
} | null;

export const useGetTimeOptions = (
  timeSlots: TimeSlotNode[]
): DropdownSelectOption<string>[] => {
  return useMemo(() => {
    if (!timeSlots?.length) return [];

    // Use a Set to ensure unique values
    const times = new Set(
      timeSlots
        .filter(Boolean) // Remove null/undefined nodes
        .map((node) => node?.time || "")
        .filter((time) => !!time)
    );

    const ret = [...times].map((time: string) => ({
      value: time,
      label: formatHHMM(time, true, true) || "",
    })) as DropdownSelectOption<string>[];

    return ret;
  }, [timeSlots]);
};

export const useGetEarlyTimeOptions = (
  timeOptions: DropdownSelectOption<string>[],
  requestedTime: string
): DropdownSelectOption<string>[] => {
  return useMemo(
    () => timeOptions.filter((o) => !requestedTime || o.value <= requestedTime),
    [timeOptions, requestedTime]
  );
};

export const useGetLateTimeOptions = (
  timeOptions: DropdownSelectOption<string>[],
  requestedTime: string
): DropdownSelectOption<string>[] => {
  return useMemo(
    () => timeOptions.filter((o) => !requestedTime || o.value >= requestedTime),
    [timeOptions, requestedTime]
  );
};
